import _ from "underscore";

export default class TreeBuilder {
    constructor(rootNode, secondLevelEntities, firstLevelEntitiesMap, firstLevelEntitiesOrder) {
        this.rootNode = rootNode;
        this.secondLevelEntities = secondLevelEntities;
        this.firstLevelEntitiesMap = firstLevelEntitiesMap;
        this.firstLevelEntitiesOrder = firstLevelEntitiesOrder;
        this.skipFirstLevel = !(this.firstLevelEntitiesMap && this.firstLevelEntitiesOrder);
        this.nodes = {};
        this.disabledNodesParents = {};
    }

    buildTree() {
        // Add nodes for enabled second level entities
        _.each(this.secondLevelEntities, function(secondLevelEntity) {
            if (this.isSecondLevelEntityEnabled(secondLevelEntity)) {
                const nodeForSecondLevelEntity = this.createTreeNodeForSecondLevelEntity(secondLevelEntity);
                const parentTreeNode = !this.skipFirstLevel ?
                                       this.getOrCreateTreeNodeForFirstLevelEntity(this.getSecondLevelEntityParentId(secondLevelEntity), true) :
                                       this.rootNode;
                parentTreeNode.appendChild(nodeForSecondLevelEntity);
                this.onTreeNodeForSecondLevelEntityAdded(nodeForSecondLevelEntity);
            }
        }, this);

        // Add nodes for disabled second level entities
        _.each(this.secondLevelEntities, function(secondLevelEntity) {
            if (!this.isSecondLevelEntityEnabled(secondLevelEntity)) {
                const nodeForSecondLevelEntity = this.createTreeNodeForSecondLevelEntity(secondLevelEntity);
                // Node, which is normally a direct parent (for enabled second level entities) is a grandparent for disabled entities
                const grandParentTreeNode = !this.skipFirstLevel ?
                                            this.getOrCreateTreeNodeForFirstLevelEntity(this.getSecondLevelEntityParentId(secondLevelEntity), true) :
                                            this.rootNode;
                // Direct node parent is a special disabled nodes parent. Create it if not created before and append to grandparent
                const parentTreeNodeId = !this.skipFirstLevel ? grandParentTreeNode.getValue().id : 0;
                let parentTreeNode = this.disabledNodesParents[parentTreeNodeId];
                if (!parentTreeNode) {
                    parentTreeNode = this.createDisabledNodesParentForSecondLevelEntity(parentTreeNodeId);
                    this.disabledNodesParents[parentTreeNodeId] = parentTreeNode;
                    grandParentTreeNode.appendChild(parentTreeNode);
                    this.onDisabledNodesParentForSecondLevelEntitiesAdded(parentTreeNode);
                }

                parentTreeNode.appendChild(nodeForSecondLevelEntity);
                this.onTreeNodeForSecondLevelEntityAdded(nodeForSecondLevelEntity);
            }
        }, this);

        if (!this.skipFirstLevel) {
            // Add nodes for enabled first level entities
            _.each(this.firstLevelEntitiesOrder, function(firstLevelEntityId) {
                const firstLevelEntity = this.firstLevelEntitiesMap[firstLevelEntityId];
                if (this.isFirstLevelEntityEnabled(firstLevelEntity)) {
                    const treeNodeForFirstLevelEntity = this.getOrCreateTreeNodeForFirstLevelEntity(firstLevelEntityId, this.createEmptyFirstLevelEntityNodes());
                    if (treeNodeForFirstLevelEntity) {
                        this.rootNode.appendChild(treeNodeForFirstLevelEntity);
                        this.onTreeNodeForFirstLevelEntityAdded(treeNodeForFirstLevelEntity);
                    }
                }
            }, this);

            // Add nodes for disabled first level entities
            _.each(this.firstLevelEntitiesOrder, function(firstLevelEntityId) {
                const firstLevelEntity = this.firstLevelEntitiesMap[firstLevelEntityId];
                if (!this.isFirstLevelEntityEnabled(firstLevelEntity)) {
                    const treeNodeForFirstLevelEntity = this.getOrCreateTreeNodeForFirstLevelEntity(firstLevelEntityId, this.createEmptyFirstLevelEntityNodes());
                    if (treeNodeForFirstLevelEntity) {
                        if (!this.disabledNodesParentForFirstLevelEntities) {
                            this.disabledNodesParentForFirstLevelEntities = this.createDisabledNodesParentForFirstLevelEntity(firstLevelEntity);
                            this.rootNode.appendChild(this.disabledNodesParentForFirstLevelEntities);
                            this.onDisabledNodesParentForFirstLevelEntitiesAdded(this.disabledNodesParentForFirstLevelEntities);
                        }

                        this.disabledNodesParentForFirstLevelEntities.appendChild(treeNodeForFirstLevelEntity);
                        this.onTreeNodeForFirstLevelEntityAdded(treeNodeForFirstLevelEntity);
                    }
                }
            }, this);
        }
    }

    getOrCreateTreeNodeForFirstLevelEntity(id, createNonExisting) {
        let treeNode = this.nodes[id];
        if (!treeNode && createNonExisting) {
            treeNode = this.createTreeNodeForFirstLevelEntity(this.firstLevelEntitiesMap[id]);
            treeNode.setLevel(1);
            this.nodes[id] = treeNode;
        }
        return treeNode;
    }

    createEmptyFirstLevelEntityNodes() {
        return false
    }

    createTreeNodeForFirstLevelEntity(firstLevelEntity) {
        // Abstract
    }

    createTreeNodeForSecondLevelEntity(secondLevelEntity) {
        // Abstract
    }

    createDisabledNodesParentForFirstLevelEntity() {
        // Abstract
    }

    createDisabledNodesParentForSecondLevelEntity(parentId) {
        // Abstract
    }

    getSecondLevelEntityParentId(secondLevelEntity) {
        // Abstract
    }

    isFirstLevelEntityEnabled(firstLevelEntity) {
        // Abstract
    }

    isSecondLevelEntityEnabled(secondLevelEntity) {
        // Abstract
    }

    onTreeNodeForFirstLevelEntityAdded(treeNode) {
        // Abstract
    }

    onTreeNodeForSecondLevelEntityAdded(treeNode) {
        // Abstract
    }

    onDisabledNodesParentForFirstLevelEntitiesAdded(treeNode) {
        // Abstract
    }

    onDisabledNodesParentForSecondLevelEntitiesAdded(treeNode) {
        // Abstract
    }
}


// WEBPACK FOOTER //
// ./web/js/usersSelector/builder/TreeBuilder.js